import { useLocation } from "react-router-dom";
import { UserContent, UserDetails } from "../../components/auth";

export default function User() {
  let location = useLocation();
  return (
    <>
      {location?.state?.page === "details" ? (
        <UserDetails dataId={location?.state?.dataId} />
      ) : (
        <UserContent />
      )}
    </>
  );
}
